
export const RESIDUE_DASHBOARD_INFO_CATEGORY                =               '/residue_dashboard/donut/category';
export const RESIDUE_DASHBOARD_INFO_TYPE                    =               '/residue_dashboard/donut/type';
export const RESIDUE_DASHBOARD_INFO_STATUS                  =               '/residue_dashboard/donut/status';

export const RESIDUE_DASHBOARD_INFO_ESTABLISHMENTE_TYPE     =               '/residue_dashboard/bar/establishment/type';
export const RESIDUE_DASHBOARD_CATEGORY_BY_YEAR             =               '/residue_dashboard/bar/category/year';
export const RESIDUE_DASHBOARD_FINAL_DESTINATION            =               '/residue_dashboard/bar/final_destination';

export const RESIDUE_DASHBOARD_MANAGEMENT                   =               '/residue_dashboard/data/management';

export const RESIDUE_DASHBOARD_COMPARE_TYPE                 =               '/residue_dashboard/kpi/type';
export const RESIDUE_DASHBOARD_COMPARE_STATUS               =               '/residue_dashboard/kpi/status';
export const RESIDUE_DASHBOARD_COMPARE_MANAGEMENT           =               '/residue_dashboard/kpi/management';

export const RESIDUE_DASHBOARD_MAP_POINTS                   =               '/residue_dashboard/map/establishment';